import { DataItem, load, urlForDataItem } from 'scrivito'

import { reportError } from '@/utils/reportError'

/**
 * Opens the details page of a data item in a new browser tab.
 *
 * The URL has to be resolved asynchronously, so the tab is opened once
 * `urlForDataItem` has loaded. A missing URL is reported instead of opening an
 * empty tab.
 */
export const openDataItemInNewTab = (dataItem: DataItem): void => {
  load(() => urlForDataItem(dataItem))
    .then((url) => {
      if (!url) {
        reportError(
          new Error(`No details page URL for data item "${dataItem.id()}"`),
        )
        return
      }

      window.open(url, '_blank')
    })
    .catch(reportError)
}
